import { render, staticRenderFns } from "./ElTableDraggable.vue?vue&type=template&id=21130118&"
import script from "./ElTableDraggable.vue?vue&type=script&lang=js&"
export * from "./ElTableDraggable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports